var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('v-container',[_c('v-row',{staticClass:"pa-0 ma-0"},[_c('h3',[_vm._v("Partner-Informationen")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }